(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-wager/assets/javascripts/calculations.js') >= 0) return;  svs.modules.push('/components/numbergames/game-wager/assets/javascripts/calculations.js');

'use strict';

const {
  rules: {
    getRules,
    system: systemRules
  },
  productMapping
} = svs.numbergames;

function calculateBoardRowCount(_ref) {
  let {
    productId,
    numbers = [],
    extraNumbers = [],
    level,
    isSystemBoard,
    systemSize
  } = _ref;
  if (isSystemBoard) {
    if (numbers.length !== (systemSize === null || systemSize === void 0 ? void 0 : systemSize.numbersSize) || extraNumbers.length !== (systemSize === null || systemSize === void 0 ? void 0 : systemSize.extraNumbersSize)) {
      return 0;
    }
  }
  const rules = getRules(productId);
  return systemRules.generatedRows({
    numbersLength: numbers.length,
    numbersExtraLength: extraNumbers.length,
    numbersRowSize: productMapping.isKeno(productId) ? level : rules.numbersMaxLength,
    numbersExtraRowSize: rules.numbersExtraMaxLength
  });
}

function calculateBoardPrice(board) {
  if (!board) return 0;
  let price = board.rowPrice;
  price *= board.rowPriceMulti;
  price *= Boolean(board.hasKungKeno) + 1;
  price *= calculateBoardRowCount(board);
  return price;
}

function calculateWagerPrice(wager) {
  if (!wager) return 0;
  let price = wager.boards.reduce((total, board) => total + calculateBoardPrice(board), 0);
  if (price) {
    var _joker$price;
    const {
      hasLotto2,
      joker,
      drawCount,
      products
    } = wager;
    price *= Boolean(hasLotto2) + 1;
    price += (_joker$price = joker === null || joker === void 0 ? void 0 : joker.price) !== null && _joker$price !== void 0 ? _joker$price : 0;
    price *= drawCount;
    price *= products.length;
  }
  return price;
}
Object.assign(svs.numbergames.gameWager, {
  calculateWagerPrice,
  calculateBoardPrice,
  calculateBoardRowCount
});

 })(window);